import React, {useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import Icon from '../../components/icon';
import Loader from '../../components/sprite/components/loader';
import Button from '../../components/button';
import {sharingPageReady} from '../../../actions/profileActions';

import {
	isApproveDeletionPopupShown as setIsApproveDeletionPopupShown,
	isRejectDeletionPopupShown as setIsRejectDeletionPopupShown
} from '../../../actions/popupActions';
import {
	fetchSuspiciousContactsDeletion,
	isConfirmApproveContactsDeletionShown as setIsConfirmApproveContactsDeletionShown,
	isConfirmRejectContactsDeletionShown as setIsConfirmRejectContactsDeletionShown,
	isContactsDeletionEnabled as setIsContactsDeletionEnabled,
	isContactsDeletionConfigLoading as setIsContactsDeletionConfigLoading,
	putSuspiciousContactsDeletionConfig,
	suspiciousContactsDeletionConfigToSend as setSuspiciousContactsDeletionConfigToSend
} from '../../../actions/suspiciousContactsDeletionActions';
import ApproveDeletionPopup from './components/approve-deletion-popup';
import RejectDeletionPopup from './components/reject-deletion-popup';
import SwitchButton from '../../components/switch-button';
import Input from '../../components/input';
import './index.css';

function ReviewDeletedContacts () {

	const deletionTypeQuantityRef = useRef(null);
	const deletionTypePercentageRef = useRef(null);
	const deletionLimitRef = useRef(null);

	const profile = useSelector((state) => state.profileReducer.getProfile);
	const suspiciousContactsDeletion = useSelector((state) => state.suspiciousContactsDeletionReducer.fetchSuspiciousContactsDeletion);
	const isLoadingSuspiciousContactsDeletionAction = useSelector((state) => state.suspiciousContactsDeletionReducer.isLoadingSuspiciousContactsDeletionAction);
	const isApproveDeletionPopupShown = useSelector((state) => state.popupReducer.isApproveDeletionPopupShown);
	const isRejectDeletionPopupShown = useSelector((state) => state.popupReducer.isRejectDeletionPopupShown);
	const isConfirmApproveContactsDeletionShown = useSelector(state => state.suspiciousContactsDeletionReducer.isConfirmApproveContactsDeletionShown);
	const isConfirmRejectContactsDeletionShown = useSelector(state => state.suspiciousContactsDeletionReducer.isConfirmRejectContactsDeletionShown);
	const isContactsDeletionEnabled = useSelector(state => state.suspiciousContactsDeletionReducer.isContactsDeletionEnabled);
	const isContactsDeletionConfigLoading = useSelector(state => state.suspiciousContactsDeletionReducer.isContactsDeletionConfigLoading);
	const suspiciousContactsDeletionConfigToSend = useSelector(state => state.suspiciousContactsDeletionReducer.suspiciousContactsDeletionConfigToSend);

	const { t } = useTranslation();

	const dispatch = useDispatch();

	const handleConfirmDeletion = () => {
		dispatch(setIsApproveDeletionPopupShown(true));
	};

	const handleCancelDeletion = () => {
		dispatch(setIsRejectDeletionPopupShown(true));
	};

	const handleToggleContactDeletion = () => {
		dispatch(setIsContactsDeletionEnabled(!isContactsDeletionEnabled));
		dispatch(setSuspiciousContactsDeletionConfigToSend({
			deletionType: 'NONE',
		}));
	};

	useEffect(() => {
		dispatch(setSuspiciousContactsDeletionConfigToSend({
			deletionType: deletionTypeQuantityRef.current?.checked ? deletionTypeQuantityRef.current?.value : deletionTypePercentageRef.current?.value,
			deletionLimit: parseInt(deletionLimitRef.current?.value, 10),
			dcaToggle: isContactsDeletionEnabled
		}));
	}, [dispatch, isContactsDeletionEnabled]);

	useEffect(() => {
		dispatch(sharingPageReady(true));
		dispatch(fetchSuspiciousContactsDeletion());

		return () => {
			if(isConfirmApproveContactsDeletionShown){
				dispatch(setIsConfirmApproveContactsDeletionShown(false));
			}
			if(isConfirmRejectContactsDeletionShown){
				dispatch(setIsConfirmRejectContactsDeletionShown(false));
			}
		}
	}, [dispatch, isConfirmApproveContactsDeletionShown, isConfirmRejectContactsDeletionShown]);

	const handleUpdateSuspiciousDeletionConfigToSend = () => {
		dispatch(setSuspiciousContactsDeletionConfigToSend({
			deletionType: deletionTypeQuantityRef.current.checked ? deletionTypeQuantityRef.current.value : deletionTypePercentageRef.current.value,
			deletionLimit: parseInt(deletionLimitRef.current.value, 10),
			dcaToggle: isContactsDeletionEnabled
		}));
	};

	const handleUpdateSuspiciousDeletionConfig = () => {
		dispatch(setIsContactsDeletionConfigLoading(true));
		dispatch(putSuspiciousContactsDeletionConfig(suspiciousContactsDeletionConfigToSend));
	};

	useEffect(() => {
		if(suspiciousContactsDeletion){
			dispatch(setIsContactsDeletionEnabled(suspiciousContactsDeletion.deletionConfiguration.dcaToggle))
		}
	}, [dispatch, suspiciousContactsDeletion]);


	return (
		<div className="container review-deleted-contacts">
			{
				suspiciousContactsDeletion
					?
					isConfirmApproveContactsDeletionShown
						?
						<div className="local-landing-page">
							<div className="local-landing-page__text">
								<p>{t('confirmApproveDeletionContactsPopupText')}</p>
								<Button className="btn-primary" onClick={() => dispatch(setIsConfirmApproveContactsDeletionShown(false))}>{t('backToMyDashboardBtn')}</Button>
							</div>
							<div className="local-landing-page__picture">
								<img src="/img/approved-contacts-deletion.png" alt="Approved contacts deletion"/>
							</div>
						</div>
						:
						isConfirmRejectContactsDeletionShown
							?
							<div className="local-landing-page">
								<div className="local-landing-page__text">
									<p>{t('confirmRejectDeletionContactsPopupText')}</p>
									<Button className="btn-primary" onClick={() => dispatch(setIsConfirmRejectContactsDeletionShown(false))}>{t('backToMyDashboardBtn')}</Button>
								</div>
								<div className="local-landing-page__picture">
									<img src="/img/rejected-contacts-deletion.png" alt="Rejected contacts deletion"/>
								</div>
							</div>
							:
							<>
								{
									isApproveDeletionPopupShown && <ApproveDeletionPopup />
								}
								{
									isRejectDeletionPopupShown && <RejectDeletionPopup />
								}
								{
									suspiciousContactsDeletion.totalNoOfContactsNeededToActionOn > 0
										?
										<div>
											<h2 className="text-danger"><Icon name="warning"/> {t('reviewDeletedContactsPageNotOkTitle')}</h2>
											<p>{suspiciousContactsDeletion?.totalNoOfContactsNeededToActionOn} {t('reviewDeletedContactsPageDeletedFromFollowingLabelsText')}</p>
											<ul>
												{
													suspiciousContactsDeletion.actionOnSharedLabels.map(item => (
														<li className="review-deleted-contacts__label">
															<div className="col-5">
																{item.groupName} <a className="external-link" rel="noreferrer" href={`http://contacts.google.com/label/${item.groupId}`} target="_blank"><Icon name="external-link"/></a>
															</div>
															<div className="col-5">
																<p>[{item.totalNumberOfContacts} {t('reviewDeletedContactsPageDeletedContactsText')}]</p>
															</div>
															<div className="col-2 text-right">
																<a className="btn btn-outline-secondary" rel="noreferrer" href={`http://contacts.google.com/label/${item.groupId}`} target="_blank">{t('reviewDeletedContactsPageViewLabelBtn')}</a>
															</div>
														</li>
													))
												}
											</ul>
											{
												isLoadingSuspiciousContactsDeletionAction
													?
													<div className="d-flex align-items-center justify-content-center mb-4">
														<Icon animated={'pulse'} name="spinner"/>
													</div>
													:
													<div className="d-flex align-items-center justify-content-center mb-4">
														<Button onClick={ handleConfirmDeletion } className="btn-primary mr-3">{t('reviewDeletedContactsPageConfirmDeletionBtn')}</Button>
														<Button onClick={ handleCancelDeletion } className="btn-outline-primary ml-3">{t('reviewDeletedContactsPageCancelDeletionBtn')}</Button>
													</div>
											}
											<div dangerouslySetInnerHTML={{__html:t('reviewDeletedContactsPageNeededToActionOnText')}} />
										</div>
										:
										suspiciousContactsDeletion.totalNoOfContactsOwnerNeededToReviewOn > 0
											?
											<div>
												<h2 className="text-danger"><Icon name="warning"/> Suspicious deletion!</h2>
												<p>{suspiciousContactsDeletion?.totalNoOfContactsOwnerNeededToReviewOn} {t('reviewDeletedContactsPageFromLabelsYouOwnText')}</p>
												<ul>
													{
														suspiciousContactsDeletion.ownerReviewLabels.map(item => (
															<li className="review-deleted-contacts__label">
																<div className="col-5">
																	{item.groupName}
																</div>
																<div className="col-5">
																	{
																		item.deleterDetails.map( item => (
																			<p>[{item.numberOfContactsDeleted} deleted contacts by <a href={`mailto:${item.deleterEmail}`} className="text-danger">{item.deleterEmail}</a>]</p>
																		))
																	}
																</div>
															</li>
														))
													}
												</ul>
												<div dangerouslySetInnerHTML={{__html:t('reviewDeletedContactsPageOwnerNeededToReviewOnText')}} />
											</div>
											:
											suspiciousContactsDeletion.totalNoOfContactsAdminNeededToReviewOn > 0
												?
												<div>
													<h2 className="text-danger"><Icon name="warning"/> Suspicious deletion!</h2>
													<p>{suspiciousContactsDeletion?.totalNoOfContactsAdminNeededToReviewOn} {t('reviewDeletedContactsPageInTheAppText')}</p>
													<ul>
														{
															suspiciousContactsDeletion.adminReviewLabels.map(item => (
																<li className="review-deleted-contacts__label">
																	<div className="col-5">
																		{item.groupName}
																	</div>
																	<div className="col-5">
																		{
																			item.deleterDetails.map( item => (
																				<p>[{item.numberOfContactsDeleted} deleted contacts by <a href={`mailto:${item.deleterEmail}`} className="text-danger">{item.deleterEmail}</a>]</p>
																			))
																		}
																	</div>
																</li>
															))
														}
													</ul>
													{
														profile.isAppAdmin ?
															isLoadingSuspiciousContactsDeletionAction
																?
																<div className="d-flex align-items-center justify-content-center mb-4">
																	<Icon animated={'pulse'} name="spinner"/>
																</div>
																:
																<div className="d-flex align-items-center justify-content-center mb-4">
																	<Button onClick={ handleConfirmDeletion } className="btn-primary mr-3">{t('reviewDeletedContactsPageConfirmDeletionBtn')}</Button>
																	<Button onClick={ handleCancelDeletion } className="btn-outline-primary ml-3">{t('reviewDeletedContactsPageCancelDeletionBtn')}</Button>
																</div>
															: ''
													}
													<div dangerouslySetInnerHTML={{__html:t('reviewDeletedContactsPageOwnerNeededToReviewOnText')}} />
												</div>
												:
												<div className="text-center">
													<h2 className="text-success"><Icon name="thumbs-up"/> {t('reviewDeletedContactsPageOkTitle')}</h2>
													<p>{t('reviewDeletedContactsPageNoDeletedContactFoundText')}</p>
												</div>
								}
								{
									profile.role === "ADMINISTRATOR" && <div className="review-deleted-contacts__options">
										<div>
											Suspicious deletion detection enabled
											<SwitchButton
												active={ isContactsDeletionEnabled }
												onClick={ handleToggleContactDeletion }
											/>
											<br />
											<span className="details">Ask my approval next time contacts are deleted.</span>
										</div>
										{
											isContactsDeletionEnabled && <div className="mt-3 form-group row align-items-center">
												<label htmlFor="nbrOfContacts" className="col-md-2 col-form-label">Trigger alert when:</label>
												<div className="col-md-2">
													<Input
														type="number"
														id="nbrOfContacts"
														defaultValue={suspiciousContactsDeletion.deletionConfiguration.deletionLimit}
														ref={ deletionLimitRef }
														onChange={ handleUpdateSuspiciousDeletionConfigToSend }
													/>
												</div>
												<div className="col-2 ml-1 ml-md-0 my-3 my-md-0">
													<div className="form-check">
														<input
															defaultChecked={ suspiciousContactsDeletion.deletionConfiguration.deletionType === "QUANTITY"}
															className="form-check-input"
															type="radio"
															name="nbrOfContactsMode"
															id="nbrOfContactsQtyMode"
															ref={ deletionTypeQuantityRef }
															value="QUANTITY"
															onChange={ handleUpdateSuspiciousDeletionConfigToSend }
														/>
														<label className="form-check-label" htmlFor="nbrOfContactsQtyMode">
															Quantity
														</label>
													</div>
													<div className="form-check">
														<input
															defaultChecked={ suspiciousContactsDeletion.deletionConfiguration.deletionType === "PERCENTAGE" }
															className="form-check-input"
															type="radio"
															name="nbrOfContactsMode"
															id="nbrOfContactsPctMode"
															ref={ deletionTypePercentageRef }
															value="PERCENTAGE"
															onChange={ handleUpdateSuspiciousDeletionConfigToSend }
														/>
														<label className="form-check-label" htmlFor="nbrOfContactsPctMode">
															Percentage
														</label>
													</div>
												</div>
											</div>
										}
										{
											JSON.stringify(suspiciousContactsDeletion.deletionConfiguration) !== JSON.stringify(suspiciousContactsDeletionConfigToSend)
												?
												isContactsDeletionConfigLoading
													?
													<div className="mt-3">
														<Button className="btn-primary" disabled={true}>
															<Icon animated={'pulse'} name="spinner"/>
														</Button>
													</div>
													:
													<div className="mt-3">
														<Button onClick={ handleUpdateSuspiciousDeletionConfig } className="btn-primary">Update</Button>
													</div>
												:
												null
										}
									</div>
								}
							</>
					:
					<Loader/>
			}

		</div>
	);
}

export default ReviewDeletedContacts;
